import classNames from 'classnames'
import React from 'react'

import * as track from '../../../track/track'

import AutoLink from '../../AutoLink'

import '../../../../scss/components/_menu.scss'

interface MenuProps {
  items: {
    id: number
    href: string
    title: string
    toSpa: boolean
    target?: string
    clickFunction?: () => void
  }[]
  modifier: string
  menuHeader?: string
}

export const Menu: React.FC<MenuProps> = ({items, modifier, menuHeader}) => {
  const classes = classNames('c-menu', {
    [`c-menu--${modifier}`]: modifier,
  })

  return (
    <nav className={classes}>
      {menuHeader && (
        <div className="item-text">
          <em>{menuHeader}</em>
        </div>
      )}
      <ul className="c-menu__list">
        {items.map((item) => (
          <li
            key={item.id}
            className={classNames('c-menu__item', {
              [`c-menu__item--${modifier}`]: modifier,
            })}
          >
            {item.clickFunction ? (
              <button className="c-menu__link" onClick={item.clickFunction} type="button">
                {item.title}
              </button>
            ) : (
              <AutoLink
                to={item.href}
                isToSpa={item.toSpa}
                target={item.target}
                className="c-menu__link"
                onClick={() => track.headerNavClicked(item.title, item.href)}
              >
                {item.title}
              </AutoLink>
            )}
          </li>
        ))}
      </ul>
    </nav>
  )
}
